export default __webpack_public_path__ + "static/media/exportDefault.fc34d027.svg";